var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06015 18.0601H10.8601V19.2601H6.06015V18.0601Z",
    fill: "#131010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4602 15.66H6.06015V16.86H14.4602V15.66Z",
    fill: "#131010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06015 13.26H12.0602V14.46H6.06015V13.26Z",
    fill: "#131010"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66016 4.13996C3.66016 3.17996 4.4344 2.45996 5.46016 2.45996H12.7883L17.9402 7.61132V19.86C17.9402 20.82 17.1659 21.54 16.1402 21.54H5.46016C4.5016 21.54 3.66016 20.7552 3.66016 19.86V4.13996ZM15.8915 7.25996L13.2602 4.62812V7.25996H15.8915ZM4.86016 19.86C4.86016 20.0976 5.16304 20.34 5.46016 20.34H16.1402C16.4987 20.34 16.7402 20.147 16.7402 19.86V8.45996H12.0602V3.65996H5.46016C5.10016 3.65996 4.86016 3.85196 4.86016 4.13996V19.86Z",
    fill: "#131010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1402 8.45996V19.14H20.3402V8.45996H19.1402Z",
    fill: "#131010"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1402 20.34H20.3402V21.54H19.1402V20.34Z",
    fill: "#131010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaper);
export default __webpack_public_path__ + "static/media/icon-paper.bb375b174f3896a101330b214816c3f9.svg";
export { ForwardRef as ReactComponent };